import type { Plugin } from 'vue'
import { installAutoPopupData } from '#src/js/autoPopup.mts'

export type Options = void

export const autoPopupPlugin = {
    install (app) {
        console.debug("installing auto popup data")
        installAutoPopupData(app)
    }
} as Plugin

export default autoPopupPlugin
